/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
Command: npx gltfjsx@6.5.3 vangards.glb 
*/

import React from "react";
import { useGLTF } from "@react-three/drei";

export default function Model(props) {
	const { nodes, materials } = useGLTF("models/vangards.glb");
	return (
		<group {...props} dispose={null}>
			<mesh
				geometry={nodes.mesh002.geometry}
				material={materials["Material.025"]}
				position={[207.736, 33.067, 7.856]}
				rotation={[Math.PI / 2, 0, Math.PI / 2]}
				scale={0.007}
			/>
			<mesh
				geometry={nodes.mesh002_1.geometry}
				material={materials["Material.057"]}
				position={[207.736, 33.067, 7.856]}
				rotation={[Math.PI / 2, 0, Math.PI / 2]}
				scale={0.007}
			/>
			<mesh
				geometry={nodes.mesh002_2.geometry}
				material={materials["Velvet texture.002"]}
				position={[207.736, 33.067, 7.856]}
				rotation={[Math.PI / 2, 0, Math.PI / 2]}
				scale={0.007}
			/>
			<mesh
				geometry={nodes.mesh002_3.geometry}
				material={materials["Material.028"]}
				position={[207.736, 33.067, 7.856]}
				rotation={[Math.PI / 2, 0, Math.PI / 2]}
				scale={0.007}
			/>
			<mesh
				geometry={nodes.mesh002_4.geometry}
				material={materials["Material.011"]}
				position={[207.736, 33.067, 7.856]}
				rotation={[Math.PI / 2, 0, Math.PI / 2]}
				scale={0.007}
			/>
			<mesh
				geometry={nodes.suit1.geometry}
				material={materials.shirts_FRONT_1828}
				position={[208.194, 33.195, 17.213]}
				rotation={[Math.PI / 2, 0, Math.PI / 2]}
				scale={0.007}
			/>
			<mesh
				geometry={nodes.suit1_1.geometry}
				material={materials["Velvet texture"]}
				position={[208.194, 33.195, 17.213]}
				rotation={[Math.PI / 2, 0, Math.PI / 2]}
				scale={0.007}
			/>
			<mesh
				geometry={nodes.suit1_2.geometry}
				material={materials["Material.058"]}
				position={[208.194, 33.195, 17.213]}
				rotation={[Math.PI / 2, 0, Math.PI / 2]}
				scale={0.007}
			/>
			<mesh
				geometry={nodes.suit1_3.geometry}
				material={materials["Material.057"]}
				position={[208.194, 33.195, 17.213]}
				rotation={[Math.PI / 2, 0, Math.PI / 2]}
				scale={0.007}
			/>
			<mesh
				geometry={nodes.suit1_4.geometry}
				material={materials["Material.050"]}
				position={[208.194, 33.195, 17.213]}
				rotation={[Math.PI / 2, 0, Math.PI / 2]}
				scale={0.007}
			/>
			<mesh
				geometry={nodes.suit1_5.geometry}
				material={materials["Material.026"]}
				position={[208.194, 33.195, 17.213]}
				rotation={[Math.PI / 2, 0, Math.PI / 2]}
				scale={0.007}
			/>
			<mesh
				geometry={nodes.suit1_6.geometry}
				material={materials["Material.011"]}
				position={[208.194, 33.195, 17.213]}
				rotation={[Math.PI / 2, 0, Math.PI / 2]}
				scale={0.007}
			/>
			<mesh
				geometry={nodes.suit1001_1.geometry}
				material={materials["Velvet texture.001"]}
				position={[208.194, 33.557, -1.326]}
				rotation={[Math.PI / 2, 0, Math.PI / 2]}
				scale={0.007}
			/>
			<mesh
				geometry={nodes.suit1001_2.geometry}
				material={materials["Material.054"]}
				position={[208.194, 33.557, -1.326]}
				rotation={[Math.PI / 2, 0, Math.PI / 2]}
				scale={0.007}
			/>
			<mesh
				geometry={nodes.suit1001_3.geometry}
				material={materials["Material.003"]}
				position={[208.194, 33.557, -1.326]}
				rotation={[Math.PI / 2, 0, Math.PI / 2]}
				scale={0.007}
			/>
			<mesh
				geometry={nodes.suit1001_4.geometry}
				material={materials["Material.043"]}
				position={[208.194, 33.557, -1.326]}
				rotation={[Math.PI / 2, 0, Math.PI / 2]}
				scale={0.007}
			/>
		</group>
	);
}

useGLTF.preload("models/vangards.glb");
